import Modal from "/WebInterface/new-ui/modules/modal.js";
import {
  shareHistoryWrapperTemplate,
  shareHistoryCardTemplate,
  shareHistoryFilesCardTemplate,
} from "/WebInterface/new-ui/upload/electron-app/electron-share-history/template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";

// returns time difference
const getTimeDifference = (date1, date2) => {
  const differenceMs = Math.abs(date1 - date2);

  const seconds = Math.floor(differenceMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  return {
    days: days ? `${days} ${t("daysAgo")}` : null,
    hours: hours ? `${hours % 24} ${t("hoursAgo")}` : null,
    minutes: minutes ? `${minutes % 60} ${t("minutesAgo")}` : null,
    seconds: seconds ? `${seconds % 60} ${t("secondsAgo")}` : null,
  };
};

// To invoke parent methods
const invoke = (method, params) => {
  if (parent.window[method]) {
    return parent.window[method].apply(this, params);
  }
};

// render local share history data
const renderShareHistoryData = () => {
  const userInfo = invoke("getUserInfo");
  const { username } = userInfo;

  // getting share history data from localstorage using loggedin username
  const shareData =
    JSON.parse(localStorage.getItem(`${username}_share_history`)) || [];

  _$("#share-history-card-wrapper").html("");

  // getting search input value
  const searchValue = _$("#search-share-history").val();

  // renders data using foreach loop
  shareData.forEach((sharedBatch) => {
    const { id, time, url, sharedItems, timestamp, sharedItemsPaths } =
      sharedBatch;

    // getting time difference in days, hours, minutes and seconds to show on card
    const { days, hours, minutes, seconds } = getTimeDifference(
      Date.now(),
      timestamp
    );

    const time_diff = days || hours || minutes || seconds;

    // filters data on the basis of search value matches the share data
    if (
      searchValue &&
      !(
        time.includes(searchValue) ||
        url.includes(searchValue) ||
        sharedItemsPaths.includes(searchValue) ||
        time_diff.includes(searchValue)
      )
    ) {
      return;
    }

    // renders card with share data
    _$("#share-history-card-wrapper")
      .el()
      .insertAdjacentHTML(
        "beforeend",
        shareHistoryCardTemplate({
          id,
          time,
          url,
          time_diff,
          files_count: sharedItems?.length,
          removeFromLocalHistoryText: t("removeFromLocalHistory"),
          CopyText: t("Copy"),
        })
      );

    // renders shared files path in a single batch one by one
    const sharedFilesContainer = _$(`#${id} .shared-files`).el();
    sharedItems.forEach((item) => {
      sharedFilesContainer?.insertAdjacentHTML(
        "beforeend",
        shareHistoryFilesCardTemplate({ file_name: item })
      );
    });

    // remove-button listener (removes particular card from the data)
    _$(`#${id} .remove-button`).on("click", () => {
      const updatedData = shareData?.filter((data) => data?.id !== id);
      localStorage.setItem(
        `${username}_share_history`,
        JSON.stringify(updatedData)
      );
      renderShareHistoryData();
    });

    // copy to clipboard button (copies url to clipboard)
    _$(`#${id} .copy-button`).on("click", () => {
      navigator.clipboard.writeText(url);
    });
  });
};

// initializes share history modal in electron app
export const initShareHistoryModal = () => {
  // getting user info
  const userInfo = invoke("getUserInfo");
  const { username } = userInfo;

  // creating modal
  new Modal({
    body: shareHistoryWrapperTemplate({}),
    show: true,
    title: t("shareHistory"),
    hasFooter: false,
    extraClasses: ["share-history-electron-modal", "p-0"],
    headerButtons: [
      {
        label: t("clearLocalHistory"),
        leftIconClasses: ["icon-trash", "text-accentMain"],
        classes: ["primary-button", "is-bordered", "p-1", "text-xs"],
        onClick: () => {
          localStorage.setItem(`${username}_share_history`, JSON.stringify([]));
          renderShareHistoryData();
        },
      },
    ],
  });

  // search input listener
  _$("#search-share-history").on("input", () => {
    renderShareHistoryData();
  });

  // rendering share history data
  renderShareHistoryData();
};
